module.exports = __webpack_public_path__ + "static/media/purityx-5.51011d80.png";